import { render } from "./VerifyLottoR3.vue?vue&type=template&id=675ddb0e"
import script from "./VerifyLottoR3.vue?vue&type=script&lang=js"
export * from "./VerifyLottoR3.vue?vue&type=script&lang=js"

import "./VerifyLottoR3.vue?vue&type=style&index=0&id=675ddb0e&lang=css"

import exportComponent from "/home/atom/Works/renny/rotto-web-admin/Front-End/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__